// extracted by mini-css-extract-plugin
export default {"servicesList":"_1tPoDiYt","list":"_11aOBJzF","moreButtonContainer":"_1WE-HNBa","blurred":"VgXs12px"};